const LEGACY_STEP_SCOPED_TAB_KEY_PREFIXES = ['stepTab_', 'outputViewerTab_', 'payloadSectionTab_'];

const buildWorkflowStepSelectionQuery = ({ currentQuery = {}, nextStepId, nextStepTab }) => {
  const query = {
    stepId: nextStepId,
    stepTab: nextStepTab || null
  };

  // Per-step tab params accumulated in the URL before step tab memory moved to
  // redux (stepTabMemory). Null removes them on the next step selection so
  // legacy URLs clean themselves up.
  Object.keys(currentQuery).forEach((key) => {
    if (LEGACY_STEP_SCOPED_TAB_KEY_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      query[key] = null;
    }
  });

  return query;
};

export default buildWorkflowStepSelectionQuery;
